import axiosInstance from '../utils/axios';

export interface Volunteer {
  responsible_person_phone: string;
  responsible_person_name: string;
  id: number;
  name: string;
  phone: string;
  gender: '男' | '女';
  age: number;
  project_id: number;
  level1?: string;
  level2?: string;
  level3?: string;
  level4?: string;
  status: 'active' | 'inactive';
  levels?: Record<string, string>;
  doctors?: Array<{
    id: number;
    name: string;
    phone: string;
  }>;
  doctorVolunteers?: Array<{
    project_id: number;
    project: {
      id: number;
      name: string;
    };
  }>;
}

export interface VolunteerQuery {
  page?: number;
  pageSize?: number;
  project_id?: number;
  doctor_id?: number;
  keyword?: string;
}

export const volunteerService = {
  // 获取志愿者列表
  getVolunteers: async (params: VolunteerQuery) => {
    const response = await axiosInstance.get('/volunteers', { params });
    return response.data;
  },

  // 获取志愿者详情
  getVolunteer: async (id: number) => {
    const response = await axiosInstance.get(`/volunteers/${id}`);
    return response.data;
  },


  // 更新志愿者
  updateVolunteer: async (id: number, volunteer: Partial<Volunteer>) => {
    const response = await axiosInstance.put(`/volunteers/${id}`, volunteer);
    return response.data;
  },

  // 删除志愿者
  deleteVolunteer: async (id: number) => {
    const response = await axiosInstance.delete(`/volunteers/${id}`);
    return response.data;
  },

  // 获取医生列表（包含当前绑定志愿者信息）
  getDoctorsWithVolunteers: async (params: {
    page?: number;
    pageSize?: number;
    project_id?: number;
    name?: string;
    hospitalName?: string;
    departmentName?: string;
    gender?: string;
    title?: string;
    phoneBindingStatus?: boolean;
  }) => {
    const response = await axiosInstance.get('/volunteers/doctors-with-volunteers', { params });
    return response.data;
  },

}; 